import { Breadcrumbs } from '../../components/layout';
import { ProductList } from '../../components/portfolio/ProductList';
import { products } from '../../content';
import './products.scss';

const breadcrumbs = [{ name: 'Our products', isActive: true }];

export const Products = () => {
  return (
    <>
      <div className="container">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1>Our products</h1>
      </div>
      <section className="container pb-2 pb-lg-3 products-container">
        <ProductList products={products} />
      </section>
    </>
  );
};
